type MultiVariantsItemProps = {
  title: string;
  variantId: string;
  variantSku: string;
  barcodeNumber: string;
  imageIndex?: string;
};

type MultiSelectorProps = {
  label: string;
  variants: MultiVariantsItemProps[];
  productDataSku: string;
};

export const multiVariantSelectorMapper = (...props) => {
  const [firstProp] = props;
  const { salsifyExternalData } = props[2];
  const { label, variants }: MultiSelectorProps = firstProp;

  return {
    variant1Dimension: { label },
    variants,
    productDataSku: salsifyExternalData.sku,
    multiVariant: true,
  };
};
